import React from 'react'
import PropTypes from 'prop-types'

import classes from './FilterModal.scss'

import { useTranslate } from 'react-redux-multilingual/lib/context'

import InputGroup from '../UI/Forms/InputGroup/InputGroup'
import Button from '../UI/Button/Button'
import Modal from '../UI/Modal/Modal'

const FilterModal = ({
  filterControls,
  filterChanged,
  filterSaved,
  cancelled,
  open,
  header,
  loadingQueue = []
}) => {
  const translate = useTranslate()
  if (!filterControls) return null

  const filterInputs = Object.entries(filterControls).map(item => {
    const [itemKey, itemAttrs] = item
    let inputType = 'newselect'
    if (itemAttrs?.inputType) {
      inputType = itemAttrs?.inputType
    }
    return (
      <InputGroup
        inputType={inputType}
        label={translate(itemAttrs?.label) || itemAttrs?.label}
        inputValue={itemAttrs?.value}
        configs={itemAttrs?.configs}
        changed={e => filterChanged(itemKey, e)}
        key={itemKey}
        loading={itemAttrs?.loading || loadingQueue.includes(itemKey)}
        hidden={itemAttrs?.hidden}
        validations={{ required: itemAttrs.required }}
      />
    )
  })

  const buttonGroups = (
    <div className={classes.ButtonGroup}>
      <span className={classes.Button}>
        <Button
          color={'primary'}
          clicked={filterSaved}
          disabled={Object.entries(filterControls).some(item => {
            let [, itemData] = item
            if (itemData.required && !itemData.value) {
              return true
            }
            return false
          })}>
          {translate('search')}
        </Button>
      </span>
      <span className={classes.Button}>
        <Button color={'default'} clicked={cancelled}>
          {translate('cancel')}
        </Button>
      </span>
    </div>
  )
  return (
    <Modal
      open={open}
      onHide={cancelled}
      header={header || translate('filter')}
      footer={buttonGroups}
      backdropClicked={cancelled}>
      <div>{filterInputs}</div>
    </Modal>
  )
}

FilterModal.propTypes = {
  open: PropTypes.bool.isRequired,
  header: PropTypes.node,
  filterControls: PropTypes.object.isRequired,
  filterChanged: PropTypes.func.isRequired,
  filterSaved: PropTypes.func,
  cancelled: PropTypes.func.isRequired,
  loadingQueue: PropTypes.arrayOf(PropTypes.string)
}

FilterModal.defaultProps = {
  open: false,
  filterSaved: () =>
    console.log('Save button clicked, add handler function to dismiss this message')
}

export default FilterModal
